var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V342.86H0V0.860352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H142V342.86H0V0.860352ZM371 0.860352H513V342.86H371V0.860352ZM306.5 206.86L356.9 181.66L331.7 169.06V143.86L281.3 169.06L306.5 118.66H281.3L256.1 80.8604L230.9 118.66H205.7L230.9 169.06L180.5 143.86V169.06L155.3 181.66L205.7 206.86L193.1 232.06H243.5V269.86H268.7V232.06H319.1L306.5 206.86Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.860352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.0c055108ee616b68775bc7f31d82613f.svg";
export { ForwardRef as ReactComponent };